import { Reveal } from "@/components/Reveal";

export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 rounded-full bg-mint px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-brand ${className}`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-brand" />
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left", className = "" }) => {
  const center = align === "center";
  return (
    <Reveal className={`${center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}>
      {eyebrow && (
        <div className={center ? "flex justify-center" : ""}>
          <Eyebrow>{eyebrow}</Eyebrow>
        </div>
      )}
      <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[hsl(var(--vc-ink))] sm:text-4xl">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-3 text-base leading-relaxed text-[hsl(var(--vc-slate))]">{subtitle}</p>
      )}
    </Reveal>
  );
};

export default SectionHeading;
